var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMobidLogo = function SvgMobidLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 175 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m118.267 67.595-29.201 74.218L59.84 67.595H.833V201.34h37.353v-90.607L72.74 201.34h27.053l35.158-91.371v91.371h39.75V67.595h-56.434ZM89.29.66c-33.834 0-59.518 20.867-62.818 51.905h35.337c3.727-11.827 13.898-19.973 27.593-19.973 13.717 0 23.731 8.146 27.413 19.973h35.292C148.785 21.527 122.921.66 89.29.66Z",
    fill: "#1774FF"
  })));
};

export default SvgMobidLogo;